import ArgType, {withErrorsAllowed} from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import {TypedValue} from 'notebook/tables/TableConstants';
import {EvaluablePrimitive, coerceToPrimitive} from 'notebook/tables/typed-values/DataTypes';

export default {
  name: 'IFERROR',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Returns a value if no error, otherwise returns an alternate value.',
  description:
    'Returns the first argument if it is not an error value, otherwise returns the second argument.',
  params: [
    {
      name: 'value',
      // TODO (BNCH-140222): Allow range inputs when array outputs are possible in Excess
      type: withErrorsAllowed(ArgType.singularValue),
      description: 'The value to check for an error.',
      coerce: (typedValue: TypedValue) => coerceToPrimitive(typedValue),
    },
    {
      name: 'value_if_error',
      // TODO (BNCH-140222): Allow range inputs when array outputs are possible in Excess
      type: withErrorsAllowed(ArgType.singularValue),
      description: 'The value to return if the first argument is an error.',
      coerce: (typedValue: TypedValue) => coerceToPrimitive(typedValue),
    },
  ],
  eval: (
    value: EvaluablePrimitive | util.CellError,
    valueIfError: EvaluablePrimitive | util.CellError
  ): EvaluablePrimitive => {
    if (value instanceof util.CellError) {
      if (valueIfError instanceof util.CellError) {
        throw valueIfError;
      }
      return valueIfError;
    }

    return value;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
